/**
 * A person's name with their address beside it, the way the document's page,
 * its audit trail and the sending page's "From" line print them.
 *
 * A member with no display name has their address in the name's place (the
 * server falls back to it), so "name (address)" printed the same address
 * twice: "by priya@example.com (priya@example.com)". The address is printed
 * once when there is no name, or when the name is the address. Case and the
 * spaces round it do not make a name different from the address.
 */
export function nameAndAddress(
  name: string | null | undefined,
  address: string | null | undefined,
  brackets: '()' | '<>',
): string {
  const n = (name ?? '').trim()
  const a = (address ?? '').trim()
  if (!a) return n
  if (!n || n.toLowerCase() === a.toLowerCase()) return a
  return `${n} ${brackets[0]}${a}${brackets[1]}`
}
